<template>
  <span>
    <!-- show image -->
    <img v-if="urlValidator(image) || haveBase64(image)" :src="image" :style="styles" />
    <img v-else :src="`data:image/png;base64,${image}`" :style="styles" />
  </span>
</template>
<script>
import validator from "validator";
export default {
  props: {
    image: String,
    user: {
      type: String,
      default: null
    },
    styles: {
      type: Object
    },
    width: {
      type: String
    },
    supportLevel: {
      type: Number,
      default: 0
    }
  },
  methods: {
    urlValidator(url) {
      if (!url) {
        return false;
      }
      return validator.isURL(url, { require_protocol: false, require_tld: false });
    },
    haveBase64(image) {
      if (image.startsWith("data:")) {
        return true;
      }
      return false;
    }
  }
};
</script>
